__turbopack_context__.v({
  "chip": "raw-module-scss-module__Wq51Aa__chip",
  "dot": "raw-module-scss-module__Wq51Aa__dot",
  "header": "raw-module-scss-module__Wq51Aa__header",
  "input": "raw-module-scss-module__Wq51Aa__input",
  "key": "raw-module-scss-module__Wq51Aa__key",
  "modified": "raw-module-scss-module__Wq51Aa__modified",
  "rotate": "raw-module-scss-module__Wq51Aa__rotate",
  "subtitle": "raw-module-scss-module__Wq51Aa__subtitle",
  "title": "raw-module-scss-module__Wq51Aa__title",
  "wrapper": "raw-module-scss-module__Wq51Aa__wrapper",
});
